// extracted by mini-css-extract-plugin
export default {"root":"DomainList-root_GCaBC","buttonContainer":"DomainList-buttonContainer_lAi3b","button":"DomainList-button_OGemH"};